const BASE_ID = 100000;

export const MODE = {
    [BASE_ID + 101]: {
        modeName: 'PC',
        key: 'pc_ac',               ///
        TITLE_START: 'PC',
    },
    [BASE_ID + 102]: {
        modeName: 'VC',
        key: 'vc_ac',     ///
        TITLE_START: 'VC',
    },
    [BASE_ID + 103]: {
        modeName: 'PRVC',
        key: 'prvc_ac',    ///
        TITLE_START: 'PRVC',
    },
    [BASE_ID + 104]: {
        modeName: 'SIMV(PC)+PS',
        key: 'pc_simv',  ////
        TITLE_START: 'SIMV(PC)+PS',
    },
    [BASE_ID + 105]: {
        modeName: 'SIMV(VC)+PS',
        key: 'vc_simv',                ////
        TITLE_START: 'SIMV(VC)+PS',
    },
    [BASE_ID + 106]: {
        modeName: 'SIMV(PRVC)+PS',
        key: 'prvc_simv',////
        TITLE_START: 'SIMV(PRVC)+PS',
    },
    [BASE_ID + 107]: {
        modeName: 'APRV',////
        key: 'aprv',
        TITLE_START: 'APRV',
    },
    [BASE_ID + 108]: {
        modeName: 'PS/CPAP',
        key: 'psv',                 ///       
        TITLE_START: 'PS/CPAP',
    },
    [BASE_ID + 109]: {
        modeName: 'VS-VC',
        key: 'vs_vc',           ///
        TITLE_START: 'VS-VC',
    },
    [BASE_ID + 110]: {
        modeName: 'VS-PRVC',
        key: 'vs_prvc',             /////
        TITLE_START: 'VS-PRVC',
    },
    [BASE_ID + 111]: {
        modeName: 'NIV-PS',
        key: 'cpap_ps',              ///
        TITLE_START: 'NIV-PS',
    },
    [BASE_ID + 112]: {
        modeName: 'HFOT',      ///
        key: 'hfot',
        TITLE_START: 'HFOT',
    },
    [BASE_ID + 113]: {
        modeName: 'DualPAP',
        key: 'niv_pc',                         ///
        TITLE_START: 'DualPAP',
    },
    [BASE_ID + 114]: {
        modeName: 'NIV-PC',                      
        key: 'niv_pc_neo', ///
        TITLE_START: 'NIV-PC',
    },
    [BASE_ID + 115]: {
        modeName: 'NCPAP',
        key: 'ncpap',                  ///
        TITLE_START: 'ncpap',
    },
    [BASE_ID + 116]: {
        modeName: 'PS-CPAP',
        key: 'cpap_ps_neo',                    ///
        TITLE_START: 'PS-CPAP',
    }
};

export const MODE_KEY_TO_ID = Object.entries(MODE).reduce(
    (acc, [id, value]) => {
        acc[value.key.toUpperCase()] = Number(id);
        return acc;
    },
    {}
);
